import { render, staticRenderFns } from "./FacebookPreview.vue?vue&type=template&id=69284086&scoped=true&"
import script from "./FacebookPreview.vue?vue&type=script&lang=ts&"
export * from "./FacebookPreview.vue?vue&type=script&lang=ts&"
import style0 from "./FacebookPreview.vue?vue&type=style&index=0&id=69284086&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69284086",
  null
  
)

export default component.exports